import { READ_ACTION, CONSULTANT_RESOURCE, DASHBOARD } from "@/constants/resources";

export default [
  {
    header: "Menu",
    resource: CONSULTANT_RESOURCE,
    action: READ_ACTION,
  },
  {
    title: "Dashboard",
    route: "dashboard",
    icon: "HomeIcon",
    resource: DASHBOARD,
    action: READ_ACTION,
  },
];
